import { Action } from "@/models/flows";
import {
  addEdge,
  applyEdgeChanges,
  applyNodeChanges,
  Edge,
  Node,
  OnConnect,
  OnEdgesChange,
  OnNodesChange,
} from "@xyflow/react";
import { create } from "zustand";

export interface FlowStore {
  // which action the user has currently clicked
  activeNode: Node | null;
  setActiveNode: (activeNode: Node | null) => void;
  nodes: Node[];
  edges: Edge[];
  onNodesChange: OnNodesChange<Node>;
  onEdgesChange: OnEdgesChange;
  onConnect: OnConnect;
  setNodes: (nodes: Node[]) => void;
  setEdges: (edges: Edge[]) => void;
  isChoosingNode: boolean;
  setIsChoosingNode: (isChoosingNode: boolean) => void;
}

export const flowSelector = (state: FlowStore) => ({
  nodes: state.nodes,
  edges: state.edges,
  setNodes: state.setNodes,
  setEdges: state.setEdges,
  onNodesChange: state.onNodesChange,
  onEdgesChange: state.onEdgesChange,
  onConnect: state.onConnect,
});

export const useFlowStore = create<FlowStore>((set, get) => ({
  activeNode: null,
  setActiveNode: (activeNode: Node | null) => set({ activeNode }),
  nodes: [],
  edges: [],
  onNodesChange: (changes) => {
    set({
      nodes: applyNodeChanges(changes, get().nodes),
    });
  },
  onEdgesChange: (changes) => {
    set({
      edges: applyEdgeChanges(changes, get().edges),
    });
  },
  onConnect: (connection) => {
    set({
      edges: addEdge(connection, get().edges),
    });
  },
  setNodes: (nodes) => {
    set({ nodes });
  },
  setEdges: (edges) => {
    set({ edges });
  },
  isChoosingNode: false,
  setIsChoosingNode: (isChoosingNode) => set({ isChoosingNode }),
}));
